import {
    call, put, takeEvery, select,
} from 'redux-saga/effects';
import { editGroupModulePermissions } from '../../requests/edit_group_module_permissions_request';
import { editGroupModulePermissionsSuccess, editGroupModulePermissionsFailure } from '../actions/edit_group_module_permissions.actions';
import { editGroupModelPermissionsSuccess, editGroupModelPermissionsFailure } from '../actions/edit_group_model_permissions.actions';
import { EDIT_GROUP_MODULE_PERMISSIONS_REQUEST } from '../constants/edit_group_data.constants';
import { message_error, message_success } from '../../../../../components/Message';
import { choose_permissions } from '../../../../../shared/helpers';

function* editGroupModulePermissionsSagaRequest({ target: { url, checked }, status }) {
    const { UserManagement: { User_group_update: { group_id, moduleOption } } } = yield select();
    const { result, options, error } = yield call(editGroupModulePermissions, group_id, url, choose_permissions(status || moduleOption, checked));
    if (result) {
        if (status === 'module') {
            yield put(editGroupModulePermissionsSuccess(options));
        } else {
            yield put(editGroupModelPermissionsSuccess(options));
        }
        message_success('Permission changed successfully!');
    } else {
        yield put(editGroupModelPermissionsFailure(error));
        yield put(editGroupModulePermissionsFailure(error));
        message_error(error);
    }
}

export default function* editGroupModulePermissionsSaga() {
    yield takeEvery(EDIT_GROUP_MODULE_PERMISSIONS_REQUEST, editGroupModulePermissionsSagaRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/redux/sagas/edit_group_module_permissions.saga.js